import PropTypes from "prop-types";
import { HeaderSection } from "./header-section";
import { FooterSection } from "./footer-section";
import Box from "@mui/material/Box";

const Layout = ({ children }) => {
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <HeaderSection />
      <Box sx={{ pb: { xs: 0, md: 0 } }}>{children}</Box>
      {/* <FooterSection /> */}
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
